import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {GridConfiguration, GridModel, GridRequest, GridResponse} from './grid.model';
import {DxDataGridComponent} from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html'
})
export class GridComponent implements OnInit, AfterViewInit {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @Input() gridConfiguration: GridConfiguration;
  @Input() gridRequest: any;
  @Output() onRowClick = new EventEmitter<any>();

  dataSource: any = {};

  constructor() {
  }


  ngOnInit() {
    const component = this;
    const conf = this.gridConfiguration;

    conf.dataGrid = component.dataGrid;

    this.dataGrid.remoteOperations = conf.remoteOperations;
    this.dataGrid.dataSource = conf.rowsDataSource;
    this.dataGrid.columns = conf.columns;
    this.dataGrid.paging = conf.paging;
    this.dataGrid.pager = conf.pager;
    this.dataGrid.selection = conf.selection;
    this.dataGrid.filterRow = conf.filterRow;
    this.dataGrid.sorting = conf.sorting;
    this.dataGrid.searchPanel = conf.searchPanel;
    this.dataGrid.columnAutoWidth = conf.columnAutoWidth;
    this.dataGrid.allowColumnResizing = conf.allowColumnResizing;
    this.dataGrid.summary = conf.summary;

    this.dataSource.store = new CustomStore({
      load: function (loadOptions) {

        conf.mapGridRequest(component.gridRequest, loadOptions);

        return component.gridConfiguration.service.getData(component.gridRequest)
          .toPromise()
          .then((response: GridResponse) => {

            return {
              data: response.rows,
              totalCount: response.totalCount,
              summary: response.summary
            };
          })
          .catch(error => {
            throw new Error(error);
          });
      }
    });

  }
  onRowClickDx(event) {
    this.onRowClick.emit(event);
  }

  ngAfterViewInit() {

  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/grid/grid.component.ts